import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {HashRouter, Route, Switch} from 'react-router-dom';
import Home from './pages/home';
import Profile from './pages/profile';
import Zajavls from './pages/zajavls';
import ZajavlsConsentOrRefusal from './pages/zajavls_consent_or_refusal';
import SettingsPage from './pages/settings';
import Page404 from './pages/page_404';
import {initDigitalProfileCabinet} from '@componentDP/js_react/redux/actions/digital_profile_cabinet';
import RatingApplicants from './pages/rating_applicants/RatingApplicants';

window.React = React;

class CabinetContainer extends React.Component {
    constructor(props) {
        super(props);
        const {initDigitalProfileCabinet} = this.props;
        initDigitalProfileCabinet();
    }
    render() {
        const {digitalProfileCabinetLoaded} = this.props;
        return (
            <div>
                {digitalProfileCabinetLoaded
                    ? <HashRouter>
                        <div className="main-menu-container">
                            <Switch>
                                <Route exact path="/" component={Home} />
                                <Route path="/profile/settings" component={SettingsPage} />
                                <Route path="/profile" component={Profile} />
                                <Route path="/zajavls/consent-or-refusal" component={ZajavlsConsentOrRefusal} />
                                <Route path="/zajavls" component={Zajavls} />
                                <Route path="/rating_applicants" component={RatingApplicants} />
                                <Route component={Page404} />
                            </Switch>
                        </div>
                    </HashRouter>
                    : null}
            </div>
        )
    };
}

function mapStateToProps(state) {
    const {apiDomainAuth, digitalProfileCabinetLoaded} = state;
    return {
        apiDomainAuth,
        digitalProfileCabinetLoaded,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initDigitalProfileCabinet,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CabinetContainer);
